//first import createConetext from the react
import {createContext} from "react";

//use createContext() funtion to create context
const noteContext = createContext();

export default noteContext;